import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import { CANONICAL_URL, DEFAULT_ICON, SITE_NAME } from '../../config';
import PropTypes from 'prop-types'

const noCrawlCheck = (props, propName) =>
{ 
  if ( !props.noCrawl && typeof props[propName] !== 'string' ) {
    return new Error(
      'Invalid prop `' + propName + '` supplied to' +
      ' `Page`.`' + propName + '` is required when crawling is enabled.'
    );
  }
}

class _Page extends Component
{
  static propTypes =
	{
    site: PropTypes.string.isRequired ,
    title: PropTypes.string.isRequired ,
    noCrawl: PropTypes.bool.isRequired,

    description: noCrawlCheck ,
    type: noCrawlCheck ,
    image: noCrawlCheck ,
  }
  
  static defaultProps =
  {
    site: SITE_NAME,
    image: DEFAULT_ICON,
    type: 'website',
    noCrawl: false
  }

  render() {
    const {
      // BASIC PROPS AND TAGS
      children, site, title, description,
      // OPEN GRAPH TAGS
      url, type, noCrawl, image,
      // EXCESS PROPS FROM THE ROUTER
      history, location, match, staticContext,
      // REMAINING PROPS ARE PASSED TO THE ROOT DIV
      ...props
      } = this.props;
    
    if(noCrawl)
    {
      return (
        <div {...props} >
          <Helmet >
            <title>{title} - {site}</title>
            <meta name="og:title" content={title} />
            <meta name="robots" content="noindex, nofollow" />
          </Helmet>
          {children}
        </div>
      ); 
    }

    const canonicalUrl = typeof url !== 'undefined' ? url : CANONICAL_URL+location.pathname;
    
    return (
      <div {...props} >
        <Helmet >
          <title>{title} - {site}</title>
          <meta name="og:title" content={title} />
          <meta name="description" content={description} />
          <meta name="og:description" content={description} />
          <meta name="og:site_name" content={site} />
          <meta property="og:type" content={type} />
          <meta property="og:url" content={canonicalUrl} />
          <meta property="og:image" content={image} />
        </Helmet>
        {children}
      </div>
    );
  }
}

export const Page = withRouter(_Page);